import React from 'react'
import axios from '~/data/http/axios'
import Alert from '~/Common-Objects/UI/Alert'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import { logoutAndClear } from '../../../data/actions/userActions'
import postHogFunctions from '~/Classes/posthog'
import moment from 'moment'
@connect((store) => {
    return { user: store.user, account: store.accountMaster }
})
export default class CloseAccountDrawer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            password: '',
            passwordErr: '',
            feedback: '',
            feedbackErr: '',
            closed: false,
            loading: false,
            reasonSelect: ''
        }

        this.goClose = this.goClose.bind(this)
    }

    componentDidMount() {}

    goClose() {
        this.setState({ passwordErr: '', feedbackErr: '' })

        let errors = false
        if (!this.state.password || this.state.password.length < 5) {
            this.setState({ passwordErr: i18n.t('company:my.closeAccount.incorrectPassword') })
            errors = true
        }

        if (!this.state.feedback || this.state.feedback.length < 3) {
            this.setState({ feedbackErr: i18n.t('company:my.closeAccount.feedbackRequired') })
            errors = true
        }

        if (errors) return

        const accountAge = moment().diff(this.props.account.accountMaster.createdAt, 'days')

        this.setState({ passwordErr: '', loading: true })
        axios
            .post('/accountmaster/closeaccount', {
                password: this.state.password,
                feedback: this.state.feedback,
                reasonSelect: this.state.reasonSelect
            })
            .then((res) => {
                postHogFunctions.capture('account_cancellation', {
                    age_of_account: accountAge
                })
                this.setState({ closed: true, loading: false })
            })
            .catch((err) => {
                let error = i18n.t('company:my.closeAccount.incorrectPassword')
                this.setState({ passwordErr: error, loading: false })
            })
    }

    continue() {
        this.props.dispatch(logoutAndClear())
    }

    render() {
        let offboardReasonsObject = i18n.t('company:my.closeAccount.feedBackOptions', { returnObjects: true })
        let offboardReasons = [
            { label: offboardReasonsObject.tooComplicated.reason, value: 'tooComplicated' },
            { label: offboardReasonsObject.tooExpensive.reason, value: 'tooExpensive' },
            { label: offboardReasonsObject.featuresMissing.reason, value: 'featuresMissing' },
            { label: offboardReasonsObject.temporary.reason, value: 'temporary' },
            { label: offboardReasonsObject.competitor.reason, value: 'competitor' },
            { label: offboardReasonsObject.somethingElse.reason, value: 'somethingElse' }
        ]
        if (this.state.loading) return <LoadingIcons iconType='2' />
        if (this.state.closed)
            return (
                <div>
                    <h4 className='mar-b25'>{i18n.t('company:my.closeAccount.closedHeader')}</h4>
                    <div className='mar-b25'>{i18n.t('company:my.closeAccount.closedDesc1')}</div>

                    <Button
                        text={i18n.t('company:my.closeAccount.closedButt')}
                        onClick={this.continue.bind(this)}
                    />
                </div>
            )
        return (
            <div>
                <h4 className='mar-b25'>{i18n.t('company:my.closeAccount.header')}</h4>
                <div className='mar-b25'>{i18n.t('company:my.closeAccount.desc1')}</div>
                <div className='mar-b25'>{i18n.t('company:my.closeAccount.desc2')}</div>

                <Select
                    label={i18n.t('company:my.closeAccount.whyAreYouClosing')}
                    name='reasonSelect'
                    value={this.state.reasonSelect}
                    data={offboardReasons}
                    onChange={(ev) => {
                        this.setState({ reasonSelect: ev.target.value })
                    }}
                    outerClassName='mar-b25'
                    placeholder='Please choose an option'
                />

                {this.state.reasonSelect && (
                    <div>
                        <TextArea
                            outerClassName='mar-b25'
                            label={
                                this.state.reasonSelect && offboardReasonsObject[this.state.reasonSelect]?.freeTextLabel
                            }
                            name='feedback'
                            style={{ height: '150px' }}
                            placeholder={i18n.t('company:my.closeAccount.thanksforFeedback')}
                            value={this.state.feedback}
                            error={this.state.feedbackErr}
                            onChange={(event) => {
                                this.setState({ feedback: event.target.value })
                            }}
                        />

                        <TextInput
                            label={i18n.t('company:my.closeAccount.instructions')}
                            outerClassName='mar-b25'
                            name='password'
                            type='password'
                            placeholder={i18n.t('company:my.closeAccount.password')}
                            value={this.state.password}
                            error={this.state.passwordErr}
                            onChange={(event) => {
                                this.setState({ password: event.target.value })
                            }}
                        />

                        {this.state.reasonSelect === 'temporary' && (
                            <Alert
                                type='error'
                                header={i18n.t('company:my.closeAccount.tempWarning')}
                                className='mar-b20'
                                content={i18n.t('company:my.closeAccount.tempWarningContent')}
                            />
                        )}

                        <Button
                            text={i18n.t('company:my.closeAccount.closeMyAccount')}
                            className='button-red'
                            onClick={this.goClose}
                        />
                    </div>
                )}
            </div>
        )
    }
}
